export const RECEIVE_HEALTH_GUIDE = 'RECEIVE_HEALTH_GUIDE';
export const REMOVE_HEALTH_GUIDE = 'REMOVE_HEALTH_GUIDE';
